import {OptionModel} from '../../model'
export const initValues: OptionModel = {
  id: '',
  nombre: '',
  padreId: '',
  orden: '',
  icono: '',
  aplicacionId: '',
}
